import React from "react";
import { Row, Col, Button, Table } from "antd";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";

const cashManagementColumn = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    width: "30%",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    width: "30%",
  },
  {
    title: "Note",
    dataIndex: "note",
    key: "note",
    width: "33%",
  },
  {
    title: "Transactions(Rs)",
    dataIndex: "amount",
    key: "amount",
    width: "20%",
    render: (text, record) => {
      return record.type === "cashOut" || record.type === "pettyCashOut" ? (
        <span style={{ color: "red" }}>-{record.amount}</span>
      ) : (
        record.amount
      );
    },
  },
];

const CashManagementView = ({ cashManagementData, setAddCashFlag, setCashAddInFlag }) => {
  const posConfig = usePOSConfigStore((s) => s.posConfig);

  return (
    <div style={{ width: "100%" }}>
      <Row style={{ width: "100%" }}>
        <Col span={24} style={{ padding: "2.65% 3.3% 0 3.3%" }}>
          <Row style={{ paddingBottom: "24px" }} gutter={[16, 16]}>
            <Col span={7} offset={17} style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
              {posConfig?.pettyCash === "N" && posConfig?.cashOut === "N" ? null : (
                <Button
                  style={{
                    width: "10.3vw",
                    height: "5.7vh",
                    border: "1px solid #0F0718",
                    borderRadius: "4px",
                    fontWeight: "600",
                    marginRight: "1.4vw",
                    fontSize: "1vw",
                    color: "#0F0718",
                  }}
                  onClick={() => {
                    setAddCashFlag(true);
                    setCashAddInFlag(true);
                  }}
                >
                  Remove Cash
                </Button>
              )}
              {posConfig?.cashIn === "Y" && (
                <Button
                  style={{ width: "10.3vw", height: "5.7vh", border: "1px solid #0F0718", borderRadius: "4px", fontWeight: "600", fontSize: "1vw", color: "#0F0718" }}
                  onClick={() => {
                    setAddCashFlag(true);
                    setCashAddInFlag(false);
                  }}
                >
                  Add Cash
                </Button>
              )}
            </Col>
          </Row>
          <Row>
            <Table
              style={{ height: "82vh", background: "#F3F4F9", padding: "2% 3.5%", width: "100%", borderRadius: "5px" }}
              pagination={false}
              columns={cashManagementColumn}
              dataSource={cashManagementData}
              className="cash-management"
            />
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(CashManagementView);
